import React from 'react';
import "@fontsource/roboto";
import './index.css';
import App from './common/ui/App';
import { BrowserRouter } from 'react-router-dom';
import SentryErrorBoundary from './common/ui/SentryErrorBoundary';
import { sentryInit } from './common/log/SentryWrapper';
import { createRoot } from 'react-dom/client';  
sentryInit();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<React.StrictMode>
  <SentryErrorBoundary>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </SentryErrorBoundary>
</React.StrictMode>);